import { SvgIcon } from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import BeeIcon from '@assets/icons/beeIcon.svg?component';

export const EmptyCartState = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack alignItems="center" spacing={3.75} useFlexGap>
        <Box sx={{ mx: 'auto', mt: '50px' }}>
          <SvgIcon component={BeeIcon} variant="emptyCartIcon" />
        </Box>

        <Typography variant="heading.detail">Your Shopping Cart is Empty</Typography>
      </Stack>
    </Box>
  );
};
